export const fetchDashboardStats = () => ({
  type: 'FETCH_DASHBOARD_STATS'
});

export const setDashboardStats = (payload) => ({
  type: 'SET_DASHBOARD_STATS',
  payload
});

export const fetchDashboardStatsError = (payload) => ({
  type: 'FETCH_DASHBOARD_STATS_ERROR',
  payload
});



// WEBPACK FOOTER //
// ./src/actions/dashboard.js